const dev = process.env.NODE_ENV === 'development'
const carCode = 'id3' // 车辆代码
const ossUrl = dev ? '' : '' // url 配置
export default{
    dev: dev,
    carConfig: {
        id3: {
            carCode: carCode,
                cameraPositon: [-65, 158, 878],
                interiorColors: [],
                pano: {
                    interiorScreen: {
                        bai: 'bai',
                        bai_back: 'bai_back',
                        hei: 'hei',
                        hei_back: 'hei_back',
                        hei2: 'hei2',
                        hei2_back: 'hei2_back',
                        zong: 'zong',
                        zong_back: 'zong_back',
                        night_bai: 'night_bai',
                        night_bai_back: 'night_bai_back',
                        night_hei: 'night_hei',
                        night_hei_back: 'night_hei_back',
                        night_zong: 'night_zong',
                        night_zong_back: 'night_zong_back'
                    },
                },
        },
    },
    decoderPath: ossUrl + 'fontre/js/',
    publicPath: ossUrl + 'fontre',
    useBasis: true,
    basisExcludeList: ['env.hdr','huanjingqiu.jpg','tire_map_c_qidong.jpg','brake_map_c_red.jpg','car_body_light_map_c.jpg','car_body_light_map_c_open.jpg'],
    bokehConfig:{
        enable: false,
        focus: 300.0,
        aperture: 5,
        maxblur: 0.01,
        maxBlurDiatance: 580
    }
}
